import _SvgIcon from "@material-ui/core/esm/SvgIcon";
import React from 'react';
export const DeleteBinIcon = props => /*#__PURE__*/React.createElement(_SvgIcon, props, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "red",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: "50",
  d: "M14.95 3.4l-.87 14.13A1.5 1.5 0 0 1 12.61 19H4.99a1.5 1.5 0 0 1-1.47-1.47L2.65 3.4m3.15 0V2.17C5.8 1.524 6.324 1 6.97 1h3.66c.646 0 1.17.524 1.17 1.17V3.4M1 3.4h15.6"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "red",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: "50",
  d: "M11.8 5.8l-.6 10.8M5.8 5.8l.6 10.8M8.8 5.8v10.8"
})))));